import { render } from "./InventoryReports.vue?vue&type=template&id=b222e940"
import script from "./InventoryReports.vue?vue&type=script&lang=js"
export * from "./InventoryReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__